"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Footer = function Footer(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginBottom: "2rem",
      clear: "both",
      width: "100%"
    }
  }, "This page is a summary of the data held in ", /*#__PURE__*/_react["default"].createElement("a", {
    href: props.outProxy + props.atlasUrl
  }, "Expression Atlas"), " for this gene; click ", /*#__PURE__*/_react["default"].createElement("a", {
    href: props.outProxy + props.moreInformationUrl
  }, "here"), " for the full record.", /*#__PURE__*/_react["default"].createElement("br", null), "Please send any queries or feedback via ", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.ebi.ac.uk/support/gxa"
  }, "the EBI Support & feedback form."), ".");
};

Footer.propTypes = {
  outProxy: _propTypes["default"].string.isRequired,
  atlasUrl: _propTypes["default"].string.isRequired,
  moreInformationUrl: _propTypes["default"].string.isRequired
};
var _default = Footer;
exports["default"] = _default;